module.exports = __webpack_public_path__ + "static/pole-pixel-villeurbanne-integral-service.bd9e3a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartUp/img/pole-pixel-villeurbanne-integral-service.jpg
// module id = 831
// module chunks = 110243015079028